import { PDFTabs } from "lib/@components/tabs"
import { Box } from "@mui/material"

export function RightBarTabsForPdf() {
    return (
        <PDFTabs
            id="ScheduleRightBar"
            tabHolder={<Box sx={{ px: 2, bgcolor: "background.neutral" }} />}
            panelHolder={<Box sx={{ m: 1 }} />}
        />
    )
}
